import { render } from "./evquote.vue?vue&type=template&id=70b87eaa&scoped=true"
import script from "./evquote.vue?vue&type=script&lang=js"
export * from "./evquote.vue?vue&type=script&lang=js"

import "./evquote.vue?vue&type=style&index=0&id=70b87eaa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-70b87eaa"

export default script